module.exports = __webpack_public_path__ + "static/img/coverImage4.6a32fded.jpg";